import styled from "@emotion/styled";
import { Heading } from "nectar-ui";
import { NectarTheme } from "@nectarTypes";

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
  @media (max-width: 425px) {
    max-width: 320px;
  }
`;

export const EmptyStateIconContainer = styled.div<NectarTheme>`
  margin-bottom: ${({ theme }) => theme.spacings.md};
  height: auto;
  @media (max-width: 425px) {
    svg {
      max-width: 320px;
      max-height: 160px;
    }
  }
`;

export const CustomHeading = styled(Heading)`
  letter-spacing: 0;
  line-height: 1.4;
`;

export const EmptyStateChildren = styled.div`
  line-height: 1.4;
  font-weight: 300;
`;
